export const months = [
    {
        id: '01',
        name: 'DATE_MONTH_1'
    },
    {
        id: '02',
        name: 'DATE_MONTH_2'
    },
    {
        id: '03',
        name: 'DATE_MONTH_3'
    },
    {
        id: '04',
        name: 'DATE_MONTH_4'
    },
    {
        id: '05',
        name: 'DATE_MONTH_5'
    },
    {
        id: '06',
        name: 'DATE_MONTH_6'
    },
    {
        id: '07',
        name: 'DATE_MONTH_7'
    },
    {
        id: '08',
        name: 'DATE_MONTH_8'
    },
    {
        id: '09',
        name: 'DATE_MONTH_9'
    },
    {
        id: '10',
        name: 'DATE_MONTH_10'
    },
    {
        id: '11',
        name: 'DATE_MONTH_11'
    },
    {
        id: '12',
        name: 'DATE_MONTH_12'
    }
];
